import { useInView } from 'react-intersection-observer';

/**
 * Custom hook for intersection observer with default options
 * @param {Object} options - Configuration options for intersection observer
 * @returns {Array} [ref, inView] - Reference and visibility state
 */
export const useIntersectionObserver = (options = {}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    ...options
  });

  return [ref, inView];
};

export default useIntersectionObserver;
